export default __webpack_public_path__ + "static/service_ap-1a39eb9b556190d603ec6f52230f55c2.png";